import { render, staticRenderFns } from "./InformationShow.vue?vue&type=template&id=17a09977&scoped=true&"
import script from "./InformationShow.vue?vue&type=script&lang=js&"
export * from "./InformationShow.vue?vue&type=script&lang=js&"
import style0 from "./InformationShow.vue?vue&type=style&index=0&id=17a09977&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a09977",
  null
  
)

export default component.exports